import { startOfDay } from 'date-fns';
import PRODUCT_LOB from '../const/productLOB';
import { getEstDateObject } from './getEstDate';
import { isSecuredInstallmentLoanProduct, isSetpayLegacyProduct } from './productTypeHelpers';
const getSetpayPSCCPaymentDays = (delinquencyDays) => {
    if (delinquencyDays < 30)
        return 365;
    if (delinquencyDays < 180)
        return 23;
    if (delinquencyDays <= 200)
        return 5;
    return 1;
};
const getSetpayRCPaymentDays = (delinquencyDays) => {
    if (delinquencyDays < 30)
        return 365;
    if (delinquencyDays < 120)
        return 30;
    if (delinquencyDays < 138)
        return 7;
    if (delinquencyDays <= 145)
        return 1;
    return 0;
};
export const getMaximumPaymentDays = (daysDelinquent, { type, lineOfBusiness }) => {
    if (isSecuredInstallmentLoanProduct(type))
        return 30;
    if (!isSetpayLegacyProduct(type))
        return 365;
    const delinquencyDays = Number(daysDelinquent);
    return lineOfBusiness === PRODUCT_LOB.RC
        ? getSetpayRCPaymentDays(delinquencyDays)
        : getSetpayPSCCPaymentDays(delinquencyDays);
};
/**
 * @description
 * This function returns the maximum date allowed for payments as a Date object
 *
 * @param {string} daysDelinquent
 * @param {Product} product
 * @returns {Date}
 */
export const getEndDateForPayment = (daysDelinquent, product) => {
    const today = startOfDay(getEstDateObject(new Date()));
    const maximumPaymentDays = getMaximumPaymentDays(daysDelinquent, product);
    const endDateFromToday = new Date(today.setDate(today.getDate() + maximumPaymentDays));
    return maximumPaymentDays === 1 ? today : endDateFromToday;
};
